import { render, staticRenderFns } from "./PricesListCard.vue?vue&type=template&id=4ccb3953&"
import script from "./PricesListCard.vue?vue&type=script&lang=js&"
export * from "./PricesListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports